// CSS 
import '@/assets/css/settings.scss';

//Lib  

// Api   

// Constant 

// Extend
import base from '@/scripts/base';

// Component    
import EmailSettings from "@/views/Settings/EmailSettings";
import NotificationSettings from "@/views/Settings/NotificationSettings";

// Function  

export default {

  extends: base,

  components: {
    EmailSettings,
    NotificationSettings,
  },

  data() {
    return {
    }
  },

  created() {
  },

  methods: {
    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion  
  },
}